import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { debug } from "@lg-plus/landing-modules";
import { useOfferRenderContext } from "./OfferRenderContext.js";
import { useOfferActionContext } from "./OfferActionContext.js";
export const LGCTAButtonProps = {
    buttonSlot: {
        type: "slot",
        displayName: "Button Slot",
    },
    amount: {
        type: "number",
        displayName: "Amount",
    },
    id: {
        type: "string",
        displayName: "Custom ID",
        advanced: true,
        description: 'By default stay empty. DOM id set already "preset-offer-action". Give rest instance its own id when the page holds more than one CTA button.',
    },
};
export function LGCTAButton({ id = "preset-offer-action", className, buttonSlot, amount, }) {
    const { offer } = useOfferRenderContext();
    const { selectOffer } = useOfferActionContext();
    const [isLoading, setIsLoading] = useState(false);
    // Wait to interactive before hydration finishes
    const isActionable = Boolean(selectOffer) && offer?.offerType === "preset";
    const handleSelect = async (event) => {
        event?.preventDefault?.();
        if (!selectOffer || offer?.offerType !== "preset") {
            return;
        }
        setIsLoading(true);
        try {
            await selectOffer({
                offerKey: offer.preset,
                payload: Number.isFinite(amount) ? { amount } : undefined,
            });
        }
        catch (err) {
            debug("Offer selection failed:", err);
        }
        finally {
            setIsLoading(false);
        }
    };
    const buttonEl = buttonSlot &&
        React.cloneElement(buttonSlot, {
            id,
            disabled: isLoading || !isActionable,
            onClick: handleSelect,
        });
    return _jsx("div", { className: className, children: buttonEl || null });
}
